import { render, staticRenderFns } from "./kTomIndex copy.vue?vue&type=template&id=1390e896&scoped=true&"
import script from "./kTomIndex copy.vue?vue&type=script&lang=js&"
export * from "./kTomIndex copy.vue?vue&type=script&lang=js&"
import style0 from "./kTomIndex copy.vue?vue&type=style&index=0&id=1390e896&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390e896",
  null
  
)

export default component.exports